import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { validate as validateUUID } from 'uuid'

import { ROUTE_NAMES } from '../constants/routes'

export default defineNuxtRouteMiddleware(async (to) => {
  if (typeof to.params.resolutionId !== 'string') return

  if (validateUUID(to.params.resolutionId)) {
    try {
      const $httpFetch = useHttpFetch()

      const { customerRequestId } = await $httpFetch(
        '/bm/customer_request/resolutions/:resolutionId/information',
        {
          method: 'GET',
          pathParams: {
            resolutionId: to.params.resolutionId,
          },
        },
      )

      // eslint-disable-next-line consistent-return
      return navigateTo({
        name: ROUTE_NAMES.CUSTOMER_CARE.CUSTOMER_REQUEST,
        params: {
          customerRequestId,
        },
        query: {
          resolution: to.params.resolutionId,
        },
      })
    } catch {
      // Do nothing
    }
  }
})
